import { TypeKeys } from '.';
import { getRemoteConfigKey } from '../global/firebase';
import { amplitudeSetUserProperties } from '../global/amplitude';

export const initExperiments = () => async (dispatch, _getState) => {
  return dispatch(getSworkitAd());
};

const getSworkitAd = () => async (dispatch, _getState) => {
  const sworkitAdsString = await getRemoteConfigKey('sworkitAd', 'string');
  if (sworkitAdsString) {
    const sworkitAd = JSON.parse(sworkitAdsString) as SworkitAd;
    dispatch(setConfigKey('sworkitAd', sworkitAd));
    if (!sworkitAd || !sworkitAd.id) return;
    amplitudeSetUserProperties({ experiment_1_ad: `${sworkitAd.id}` });
  }
};

// const showOnboardingSkip = () => async (dispatch, _getState) => {
//   const show_skip_onboarding = (await getRemoteConfigKey(
//     'show_skip_onboarding',
//     'boolean'
//   )) as SworkitState['experiments']['show_skip_onboarding'];
//   if (show_skip_onboarding) {
//     dispatch(setConfigKey('show_skip_onboarding', show_skip_onboarding));
//   }
// };

export interface SetRemoteConfigKey {
  type: TypeKeys.SET_REMOTE_CONFIG_KEY;
  key: keyof SworkitState['experiments'];
  value: SworkitState['experiments'][keyof SworkitState['experiments']];
}

function setConfigKey(
  key: keyof SworkitState['experiments'],
  value: SworkitState['experiments'][keyof SworkitState['experiments']]
) {
  const action: SetRemoteConfigKey = {
    type: TypeKeys.SET_REMOTE_CONFIG_KEY,
    key,
    value,
  };
  return action;
}
